import React from "react";
import PlayerProgressBarTest from "../../PlayerProgressBarTest";
const Screen08 = () => {
    return <PlayerProgressBarTest />;
};

export default Screen08;
